import { isNotNullOrUndefined } from '@vy/utils';
import { useFormContext } from 'react-hook-form';
import { VySelect } from '@vy/ui-design-system';
import { useChargeContext } from '../../charge-context';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import {
  METER_INTERVAL_OPTIONS,
  findMeterIntervalOption,
  getMeterIntervalLabel,
  type MeterIntervalOption,
} from './meter-interval-options';

export const MeterResetSelect: React.FC = () => {
  const { itemIndex: productIndex } = useChargeContext();
  const { watch, setValue } = useFormContext<PlanInputForm>();

  const accumulationIntervalValue = watch(`usageProducts.${productIndex}.accumulationInterval`);

  const handleChange = (_event: React.SyntheticEvent, next: MeterIntervalOption | null) => {
    const nextValue = next?.value ?? null;

    if (isNotNullOrUndefined(nextValue)) {
      setValue(`usageProducts.${productIndex}.accumulationInterval`, nextValue);
      return;
    }

    // Clearing reset must also cascade-clear commitment fields (legacy parity).
    setValue(`usageProducts.${productIndex}.accumulationInterval`, undefined);
    setValue(`usageProducts.${productIndex}.commitment.replenishmentInterval`, undefined);
    setValue(`usageProducts.${productIndex}.commitment.autoRefillEnabled`, false);
  };

  return (
    <VySelect<MeterIntervalOption>
      label="Meter Reset"
      helperText="Usage will accumulate over the invoice period and reset at the start of the next one"
      options={METER_INTERVAL_OPTIONS}
      getOptionLabel={getMeterIntervalLabel}
      value={findMeterIntervalOption(accumulationIntervalValue)}
      onChange={handleChange}
      isOptionEqualToValue={(option, optionValue) => option.value === optionValue.value}
      data-vy="usage-charge-drawer-meter-reset-select"
    />
  );
};
